import useSWR from 'swr';

import { fetchOrganizationCustomization } from '../api/organizationCustomization';
import { OrganizationCustomizationResponse } from '../types/organization';

export const useOrganizationCustomization = (organizationId?: number) => {
  const { data, error, isLoading, mutate } =
    useSWR<OrganizationCustomizationResponse>(
      organizationId ? `organization-customization-${organizationId}` : null,
      () => fetchOrganizationCustomization(organizationId!),
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        dedupingInterval: 60000,
        fallbackData: organizationId
          ? {
              organizationId,
              customization: null,
            }
          : undefined,
      }
    );

  return {
    customization: data?.customization || null,
    isLoading,
    error,
    mutate,
  };
};
